<template>
    <v-autocomplete
        ref="region"
        v-model.trim="region"
        :disabled="!to.filter.hosp"
        :readonly="!to.filter.hosp"
        :clearable="true"
        color="teal"
        label="Region"
        :items="getToRegions"
        auto-select-first
        item-text="city_region"
        autocomplete="nope"
        @click:clear="handleClearToRegion"
        @change="handleChangeToRegion($event)"
    />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['to', 'member_model', 'loading'],
    data: ()=>({
        region: null
    }),
    computed: {
        ...mapGetters(['getToRegions', 'getToProvinces', 'getToCities'])
    },
    watch: {
        getToCities() {
            this.loading.to.city = false
        },
        getToProvinces() {
            this.loading.to.province = false
        },
        'to.region'(newVal) {
            this.region = newVal
        }
    },
    methods: {
        ...mapActions(['toProvinces', 'toCities', 'toHospClin']),
        handleChangeToRegion(value) {
            this.to.region = value
            // if (value && this.to.facility && String(this.to.facility.hosp_region).trim() !== String(value).trim()) {
            this.to.province = ''
            this.to.city = ''
            this.to.facility = ''
            this.to.filter.doc = false
            this.to.specField = { sp_name: 'ALL', sp_desc: '' }
            this.to.hospClinDoctor = ''
            // }
            this.to.hospClinType = 'H'
            this.to.decking = ''
            this.loading.to.province = true
            this.toProvinces({ REGION: value })
            this.loading.to.city = true
            this.toCities({ REGION: value, PROVINCE: this.to.province })
            this.loading.to.hospital = true
            this.toHospClin({ REGION: value ? value : '', PROVINCE: this.to.province ? this.to.province : '', CITY: this.to.city ? this.to.city : '', TYPE: '', MEMBN: this.member_model.MEMB_N })
        },
        handleClearToRegion() {
            this.to.region = null
            this.to.province = null
            this.to.city = null
        }
    }
}
</script>
